import Vue from "vue";
import { getInstance } from "./authWrapper";
import { LOGIN_ROUTE, poToken, validatePoSession, fetchAuthConfig } from "./poSession";
import { rememberLoginTarget } from "./loginTarget";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = async () => {
    try {
      const session = await validatePoSession();
      if (session && session.authenticated === true) {
        return next();
      }
    } catch (error) {
      // A missing, expired, cross-site, or revoked PO token is not a session.
      // A slow or failed check (item H) keeps a held token; every API call
      // is still authorized by the backend.
      if (error && error.poTransient && poToken()) {
        return next();
      }
    }

    // Only send an unauthenticated visitor to the Auth0 Universal Login when the
    // site is actually running Auth0. When Auth0 is off (auth-config method:
    // "local"), a loginWithRedirect lands on the Auth0 error page — so fall back
    // to the local login form instead. fetchAuthConfig fails closed to Auth0
    // (auth0Only: true), matching the local/auth0 decision Login.vue makes.
    let auth0Only = true;
    try {
      ({ auth0Only } = await fetchAuthConfig(Vue.prototype.$apiurl));
    } catch (error) {
      auth0Only = true;
    }

    if (
      auth0Only &&
      authService &&
      !authService.loading &&
      !authService.isAuthenticated
    ) {
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
      return next(false);
    }
    rememberLoginTarget(to.fullPath);
    return next(LOGIN_ROUTE);
  };

  if (!authService) {
    rememberLoginTarget(to.fullPath);
    return next(LOGIN_ROUTE);
  }
  if (!authService.loading) {
    return fn();
  }

  const unwatch = authService.$watch("loading", loading => {
    if (loading === false) {
      unwatch();
      return fn();
    }
  });
};
